// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"549586a8","787":"22f0931b"}[chunkId] + ".chunk.js";
};